export const ROUTE = {
  HOMEPAGE: '/',
  VOTING: '/voting/',
  WINNERS: '/winners/',
  THANK_YOU: '/thank-you/',
  CEO_VOTING: '/awards/ceo-voting/',
  CEO_VOTING_THANK_YOU: '/awards/ceo-voting/thank-you/'
}

export const ROUTE_NAMES_WITH_PAGINATION = []

export const ROUTE_NAME = {
  HOMEPAGE: 'index',
  VOTING: 'voting',
  WINNERS: 'winners',
  THANK_YOU: 'thank-you',
  CEO_VOTING: 'awards-ceo-voting',
  CEO_VOTING_THANK_YOU: 'awards-ceo-voting-thank-you'
}
